export function track(eventName, payload = {}) {
  try {
    if (typeof window !== 'undefined') {
      window.__analyticsQueue = window.__analyticsQueue || [];
      window.__analyticsQueue.push({ event: eventName, payload, ts: Date.now() });
    }
    // Placeholder for GA/other telemetry wiring
    // console.log('[analytics]', eventName, payload);
  } catch (_) {
    // Best effort only
  }
}


